import { createFileRoute } from '@tanstack/react-router';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/vulnerabilities')({
  staticData: {
    owner: CodeOwner.Uvm,
  },
  beforeLoad: ({ context, preload }) => {
    context.validateAppPermission('VULNERABILITIES', preload);
  },
});
